import React from 'react'

export default function ListItem(props) {
  return <li className="list-item pl-3 mb-4">{props.children}</li>
}
